import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Main from "./components/Main";
import Nav from "./components/Nav";
import Sidebar from "./components/Sidebar";
import AddNewJob from "./pages/AddNewJob";
import EditJob from "./pages/EditJob";
import Home from "./pages/Home";
import "./styles/style.css";

function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Layout>
        <Sidebar />
        <Main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/addNewJob" element={<AddNewJob />} />
            <Route path="/editJob/:jobsId" element={<EditJob />} />
          </Routes>
        </Main>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
